<template>
  <form class="reagendar" @submit="reagendar" onsubmit="return false">
    <div class="row column-s wrap">
      <div class="grid-3 grid-12-s">
        Cliente <br />
        <strong>{{ modal.job.nome_cliente }}</strong>
      </div>
      <div class="grid-4 grid-12-s">
        Supporter <br />
        <strong>{{ modal.job.nome_doutor }}</strong>
      </div>
      <div class="grid-4 grid-12-s">
        Gestor de Demanda <br />
        <strong>{{ modal.job.nome_gestor }}</strong>
      </div>
      <div class="grid-12">
        Problema <br />
        <strong>{{ modal.job.problema }}</strong>
      </div>
    </div>
    <div class="row column-s wrap grid-11-s align-center" style="margin-top: 15px">
      <div class="grid-11">
        Motivo do reagendamento <br />
        <input class="input" v-model="form.motivo_reagendamento" required />
      </div>
      <div class="grid-4">
        <div class="label">Causa do reagendamento</div>
        <select class="input" v-model="form.id_flag_reagendamento">
          <option value="">Selecione</option>
          <option v-for="flag of flags" :value="flag.id" :key="flag.id"> {{ flag.flag }}</option>
        </select>
      </div>
      <div class="grid-4" style="margin-top:-15px">
        Urgência <br />
        <select v-model="form.urgencia_atendimento" required>
          <option value>Selecione</option>
          <option value="imediato">Atendimento Imediato (Até 1 hora)</option>
          <option value="agendado">Atendimento Agendado</option>
        </select>
      </div>
      <div class="grid-6" v-if="form.urgencia_atendimento == 'agendado'">
        Agendamento 
        <div class="row align-center">
          <input class="grid-8" type="date" v-model="data" /> &nbsp;
          <input class="grid-4" type="time" v-model="hora" />
        </div>
      </div>
    </div>

    <div class="controls row">
      <Button type="submit" :loader="loader" layout="green-go">REAGENDAR</Button>
    </div>
  </form>
</template>

<script>
import { mapActions } from "vuex";
import Button from "@/components/Button.vue";
export default {
  name: "Reagendar",
  props: { modal: Object },
  components: { Button },
  data() {
    return { flags: [], loader: false, data: '', hora: '', form: { motivo_reagendamento: '', urgencia_atendimento: '', id_flag_reagendamento: "" } };
  },
  beforeMount() {
    this.FLAGS_LIST({ status: "ativo", filtro: 'reagendamento' }).then(({ data }) => this.flags = data || []);
  },
  methods: {
    ...mapActions("admin", ["REAGENDAR", "FLAGS_LIST"]),
    async reagendar() {
      if (confirm("Deseja reagendar este Job?")) {
        this.loader = true
        this.form.dh_agendamento_cliente = this.data ? this.data + ' ' + this.hora : null
        this.form.id = this.modal.job.id
        await this.REAGENDAR(this.form)
        this.loader = false
        this.modal.show = false
        this.modal.cb()
      }
    }
  },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.reagendar 
  padding: 30px
  max-width: 600px
  @include label        
  .input
      margin-top: 8px
      margin-bottom: 22px
  strong
      font-size: 16px
      color: $gray-1
  span
      color: orange  
  .grid-12-s, .grid-12
      margin-top: 20px
  .controls
    margin-top: 50px
  
</style>